import { Show, useForm } from "@refinedev/antd";
import { useList } from "@refinedev/core";
import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from "antd";
import { useMatch } from "react-router-dom";

import { AppTitle } from "../../../components";
import { errorNotification, successNotification } from "../../../helpers";
import { PlayerAwardItem, PlayerAwardType } from "../Lib";
import { AwardsDelete } from "../Awards-Delete/Awards-Delete";

export const AwardsShow = () => {
  const route = useMatch("/:parent/:id");
  const id = Number(route?.params.id);
  const { formProps, formLoading } = useForm<PlayerAwardItem>({
    resource: "awards",
    action: id ? "edit" : "create",
    id,
    dataProviderName: "awardsDataProvider",
    redirect: "list",
    ...successNotification({
      successData: {
        message: id ? "Награда изменена" : "Награда добавлена",
        type: "success",
      },
    }),
    ...errorNotification({}),
  });
  const { data: awardTypesData, isFetching: isAwardTypesLoading } =
    useList<PlayerAwardType>({
      dataProviderName: "awardTypesDataProvider",
      resource: "award-types",
      pagination: {
        mode: "off",
      },
      ...errorNotification({}),
    });

  const awardTypes = awardTypesData?.data ?? [];

  return (
    <Show
      isLoading={formLoading}
      title={
        <AppTitle isLoading={formLoading} canGoBack>
          {id ? "Редактировать награду" : "Добавить награду"}
        </AppTitle>
      }
      breadcrumb={false}
      headerButtons={
        <Space direction={"horizontal"}>
          {Boolean(id) && (
            <AwardsDelete
              name={formProps.initialValues?.text || "награда"}
              id={id}
              type={"page"}
            />
          )}
        </Space>
      }
      footerButtons={null}
      goBack={false}
    >
      <Form {...formProps} layout={"vertical"}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name={"awardTypeId"}
              label={"Тип награды:"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо выбрать тип награды",
                },
              ]}
            >
              <Select
                placeholder={"Выберите тип награды"}
                loading={isAwardTypesLoading}
                options={awardTypes.map((awardType) => ({
                  value: Number(awardType.id),
                  label: awardType.displayName || awardType.name,
                }))}
                showSearch
                optionFilterProp="label"
              />
            </Form.Item>
            <Form.Item
              name={"text"}
              label={"Описание:"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать описание",
                },
              ]}
            >
              <Input.TextArea
                placeholder={"Укажите описание"}
                autoSize={{ minRows: 4, maxRows: 8 }}
              />
            </Form.Item>
            <Form.Item
              name={"dateFrom"}
              label={"Дата:"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать дату награды",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder={"Укажите дату награды"}
                format={"DD.MM.YYYY"}
              />
            </Form.Item>

            <Space>
              <Button type={"primary"} htmlType={"submit"}>
                {id ? "Отредактировать" : "Добавить награду"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Show>
  );
};
